<template>
	<!-- 研发服务平台 -->
	<div class="container">
		<p class="indent" v-if="$i18n.locale == 'zh'">{{research.title}}</p>
		<p class="indent" v-else-if="$i18n.locale == 'en'">{{research.y_title}}</p>
		<p class="indent" v-else>{{research.e_title}}</p>

		<p class="indent" v-if="$i18n.locale == 'zh'" v-html="research.content"></p>
		<p class="indent" v-else-if="$i18n.locale == 'en'" v-html="research.y_content"></p>
		<p class="indent" v-else v-html="research.e_content"></p>
	</div>
</template>

<script>
	export default {
		data() {
			return {
        research:{},
				id:''
			}
		},
		mounted() {
			this.getResearch()
			
		},
		methods: {
			getResearch() {
				var that = this;
				this.$axios
					.post("/api/index/research_info", {
						id:this.$route.query.id
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.research = ret.data.data.research;
							let data = ret.data.data;

							that.research.content = that.imgTagAddStyle(data.research.content)
							that.research.y_content = that.imgTagAddStyle(data.research.y_content)
							that.research.e_content = that.imgTagAddStyle(data.research.e_content)
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
			// 
			imgTagAddStyle (htmlstr) {
				var regex0 = new RegExp("(i?)(\<img)([^\>]+\>)", "gmi") //正则匹配表达式
				// htmlstr = htmlstr.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
				// htmlstr = htmlstr.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
				// htmlstr = htmlstr.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
	
				let str = htmlstr.replace(regex0,"$2 style='display:block;width:100%;height:auto;' $3");
				return str
			},
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 900px;
		display: flex;
		flex-direction: column;

		.image1 {
			width: 900px;
			height: 500px;
		}

		.title {
			font-size: 30px;
			font-weight: bold;
			color: #333333;
			padding: 40px 0;
		}
		.indent{
			text-indent: 2em;
			text-align: center;
		}
		p{
			font-size: 16px;
			color: #333;
			margin-bottom: 30px;
		}
		.text{
			font-size: 18px;
			font-weight: bold;
			color: #004098;
			margin-bottom: 10px;
		}
		.census {
			width: 100%;
			height: 300px;
			position: relative;
			margin-bottom: 20px;
			.el-image {
				width: 100%;
				height: 300px;
			}
			.range {
				width: 100%;
				height: 300px;
				position: absolute;
				top: 0;
				left: 0;
				background-color: rgba($color: #004098, $alpha: 0.8);
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				justify-content: space-between;
				.li {
					width: 25%;
					height: 150px;
					font-size: 16px;
					color: #fff;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
				
					.el-image {
						width: 50px;
						height: 50px;
						margin-bottom: 10px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/service/cro.vue